import { type FC } from 'react';

import Chips from '@/components/Chips';
import type * as ApiModels from '@/typings/api-models';

type TeamMember = Pick<ApiModels.TeamMember, 'email' | 'id' | 'image' | 'name' | 'primaryColour'>;

/** Renders a chip selector for choosing among available team members when booking. */
type TeamMemberChipsProps = {
  teamMembers: TeamMember[];
  selectedTeamMemberPersonId: string | null;
  onSelect: (id: string | null) => void;
};

const TeamMemberChips: FC<TeamMemberChipsProps> = ({ teamMembers, selectedTeamMemberPersonId, onSelect }) => {
  const handleSelect = (id: string | null) => {
    // Don't allow deselecting all team members
    if (!id) {
      return;
    }
    onSelect(id);
  };

  return (
    <Chips
      data={teamMembers.map((teamMember) => ({
        id: teamMember.id,
        label: teamMember.name || teamMember.email || teamMember.id,
        userImage: {
          color: teamMember.primaryColour?.hex,
          name: teamMember.name || undefined,
          url: teamMember.image?.url,
        },
      }))}
      wrap
      selectedItem={selectedTeamMemberPersonId}
      onItemClick={handleSelect}
    />
  );
};
export default TeamMemberChips;
